module.exports = __webpack_public_path__ + "static/media/settings.b76cab50.svg";